<div *ngIf="searchResult" class="container-searchResults">
    <!-- Search Text -->
    <div class="container-searchResults__container-searchBar bg-brand-99">
        <div class="container-searchResults__container-searchBar__container-input position-relative container-xxl">
            <input class="form-control" type="text" placeholder="{{'SEARCH_BAR.PLACEHOLDER_SEARCH_ALL' | translate}}"
                [formControl]="searchValue" [ngClass]="{'border-custom': searchValue.value}">
            <div class="container-searchResults__container-searchBar__container-input__container-image cursor-pointer"
                (click)="search()">
                <img loading="lazy" src="../../../../../assets/images/search.png" alt="search icon">
            </div>
        </div>
        <div class="container-select-course__title text-center">
            <p class="text-brand-10 ls-label-medium-semibold text-uppercase">
                {{"BLOCK.VIEW_SELECT_FILTERS.FILTER_CONTENTS" | translate}}
            </p>
        </div>
        <!-- Select -->
        <ng-container *ngIf="data_tipi_contenuto">
            <div class="container-general p-3 mb-5 container-xxl">
                <div class="container-general__container-dropdown">
                    <div ngbDropdown #myDrop="ngbDropdown" placement="center"
                        class="d-inline-block w-100 bg-white container-general__container-dropdown__ngbdrop">
                        <button type="button"
                            class="btn container-general__container-dropdown__ngbdrop__btn-custom b-grey w-100 d-flex justify-content-between align-items-center ls-label-large"
                            id="{{ 'dropdown-' + data_tipi_contenuto.id }}" ngbDropdownToggle
                            [ngClass]="{'b-success': isValue}">
                            {{ itemLength > 1 ? itemLength : '' }} {{ titleDropdown | translate }}
                            <i class="fa-solid fa-angle-down text-success" aria-hidden="true"></i>
                        </button>
                        <div class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu" ngbDropdownMenu
                            [attr.aria-labelledby]="'dropdown-' + data_tipi_contenuto.id">
                            <div
                                class="d-flex justify-content-between align-items-center container-general__container-dropdown__ngbdrop__ngbDropdownMenu__header">
                                <p class="m-0 ls-label-small-semibold text-uppercase">
                                    {{ data_tipi_contenuto.titolo | translate}}</p>
                                <div class="cursor-pointer" (click)="$event.stopPropagation(); myDrop.close();">
                                    <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                                </div>
                            </div>
                            <form [formGroup]="checkboxGroupForm"
                                class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form">
                                <div
                                    class="d-flex flex-column justify-content-between container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox">
                                    <div
                                        class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general">
                                        <div
                                            class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general__checkbox-box">
                                            <div class="d-flex align-items-center container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general__checkbox-box__cont-label"
                                                *ngFor="let order of checkArray | async; let i = index">
                                                <label class="col-2" formArrayName="checkbox">
                                                    <input type="checkbox" [formControlName]="i">
                                                </label>
                                                <p class="m-0 col-10 ls-p">{{order.value | translate}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-success w-100 btn-submit text-uppercase"
                                        (click)="submitSelect(); $event.stopPropagation(); myDrop.close();">
                                        {{"SEARCH_BAR.CONFIRM" | translate}}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <!-- END Select 
        <div class="container-searchResults__container-searchBar__container-cta d-flex justify-content-center">
            <button *ngIf="true" class="btn btn-success ls-label-medium-semibold text-uppercase"
                (click)="search(true)">{{"SEARCH_BAR.SEARCH" | translate}}</button>
        </div>-->

        <div class="container-select-course__cta position-relative d-flex justify-content-center align-items-center">
            <button (click)="search(true)" class="btn ls-label-medium-semibold text-uppercase btn-success">{{"SEARCH_BAR.SEARCH" | translate}}</button>
            <div class="cursor-pointer position-absolute container-select-course__cta__container-reset-btn">
                <p (click)="resetValue()" class="ls-label-small-semibold text-uppercase text-brand-40 m-0">{{ "BLOCK.VIEW_SELECT_FILTERS.RESET" | translate }}</p>
            </div>
        </div>
    </div>
    <!-- END Search text -->
    <!-- Result -->
    <div *ngIf="searchResult.length"
        class="container container-searchResults__container-card d-flex flex-wrap justify-content-center">
        <ng-container *ngFor="let result of searchResult">
            <div *ngIf="result" class="container-search-item bg-neutral-A1 position-relative col-12 width-custom cursor-pointer" 
                [routerLink]="navigationService.splitUrlRouterLink(setTitle(result).link).path" [queryParams]="navigationService.splitUrlRouterLink(setTitle(result).link).queryParams">
                <div class="container-search-item__badge position-absolute bg-brand-90">
                    <p class="m-0 ls-label-small-semibold text-brand-40 text-uppercase"
                        [innerHTML]="result.content_type">
                    </p>
                </div>
                <div *ngIf="setTitle(result)"
                    class="container-search-item__category d-flex justify-content-center align-items-center h-100">
                        <h3 class="ls-h3-item-title-small" [innerHTML]="setTitle(result).title"></h3>
                </div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="wait" class="mt-custom text-center">
        <div class="container-spinner d-flex justify-content-center align-items-center">
            <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">{{"BLOCK.SPINNER.LOADING" | translate}}</span>
              </div>
        </div>
    </div>
    <ng-container *ngIf="!searchResult.length && !wait">
        <div class="mt-custom">
            <h2 class="text-center ls-h2-section-title text-brand-10">
                {{"SEARCH_BAR.NO_RESULTS" | translate}}
            </h2>
            <p class="text-center ls-p text-neutral-40">
                {{"SEARCH_BAR.MODIFY_SEARCH" | translate}}
            </p>
        </div>
    </ng-container>
    <!-- END Result -->
    <!-- CTA -->
    <div  class="d-flex justify-content-center align-items-center p-5">
        <button *ngIf="viewMore" class="btn-header-news ls-label-small-semibold text-uppercase"
            (click)="addContentResult()">{{"SEARCH_BAR.SHOW_MORE" | translate}}
        </button>
    </div>
    <!-- END CTA -->
</div>